export const isObject = variable => (variable !== null && typeof variable === 'object' && variable.constructor.toString().indexOf("Object") !== -1)

